import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppBaseComponent } from '../../app-base.component';
import { InformationSourceDto, InformationSourceService, InformationSourceState } from '@proxy/information-sources';
import { AppConsts } from '../../AppConsts';

@Component({
    selector: 'app-information-sources-dropdown',
    templateUrl: './information-sources-dropdown.component.html',
    standalone: false
})
export class InformationSourcesDropdownComponent  extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() selectedInformationSourcesId: number[];

  @Output() changeInformationSources = new EventEmitter<InformationSourceDto[]>();
  
  informationSources: InformationSourceDto[];
  selectedInformationSources: InformationSourceDto[];

  constructor(
    injector: Injector,
    private readonly _informationSourceService: InformationSourceService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getInformationSources();
  }

  async getInformationSources(): Promise<void> {
    try {
      this.showLoading();
      const result = await firstValueFrom(this._informationSourceService.getAllInformationSourcesByInput({
        skipCount: undefined,
        maxResultCount: AppConsts.MaxPageSize,
        state: InformationSourceState.Active,
      }));

      this.informationSources = result.items;

      this.selectedInformationSources = this.informationSources
        .filter(x => this.selectedInformationSourcesId?.includes(x.id));

      if (this.isDefinedAndStrictlyPositiveNumber(this.selectedInformationSources?.length)) {
        this.onSelected();
      }
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeInformationSources.emit(this.selectedInformationSources);
  }
}
